import { css } from "@emotion/react";

export const textFieldCss = (hasError?: boolean) => css`
  line-height: 1.5em;
  padding: 4.5px 12px;
  border-radius: 25px;
  background: white;
  font-size: 1rem;
  vertical-align: baseline; //kvůli nevycentrovanéme textovému poli v editovaném řádku tabulky
  min-height: 40px;
  outline: none;
  box-sizing: border-box;
  border: 1px solid ${hasError ? "red" : "#ced4da"};

  fieldset {
    border: none;
  }
`;

export const dateFieldCss = (hasError: boolean) => css`
  ${textFieldCss(hasError)};
  width: 100%;
  height: 100%;
  min-width: 150px;

  display: flex;
  justify-content: center;

  button {
    padding: 0;
    width: 16px;
    height: 16px;
  }

  input {
    font-size: 12px !important;
  }

  @media only screen and (max-width: 1024px) {
    min-width: auto;
  }
`;

export const textFieldInputCss = css`
  padding: 0;
  height: 24px;
  font-family: "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto",
    "Helvetica Neue", "Arial", "sans-serif", "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
`;
